export default [
  {
    path: '/report/download',
    name: 'report.download',
    component: () => import('views/private/report/ReportDownload'),
    query: {},
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/report',
    name: 'report.main',
    component: () => import('views/private/report/ReportBuilder'),
    children: [
      {
        path: ':templateId',
        name: 'report.template',
        component: () => import('views/private/report/ReportBuilder'),
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
];
